module.exports = __webpack_public_path__ + "static/media/SOAK.e011f915.png";